<template>
  <div class="animated fadeIn">
    <PriceTemplateNew />
  </div>
</template>
<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import PriceTemplateNew from '@/components/priceTemplate/PriceTemplateNew.vue';
@Component({
  components: {
    PriceTemplateNew
  }
})
export default class PriceTemplateCreate extends Vue {
}
</script>
